export const LOGO_MAIN =
  "https://customer-assets.emergentagent.com/job_9c238b13-bde0-4507-8963-701f313010d1/artifacts/69vuxxik_Hawaii_Housing_Foundation_Logo_HighRes.png";

export const LOGO_SEAL =
  "https://customer-assets.emergentagent.com/job_9c238b13-bde0-4507-8963-701f313010d1/artifacts/pvfbqsbp_hawaii-housing-foundation-seal-logo.png";

export const IMG_HERO =
  "https://images.pexels.com/photos/34120065/pexels-photo-34120065.jpeg";

export const IMG_ABOUT =
  "https://images.pexels.com/photos/4609726/pexels-photo-4609726.jpeg";

export const IMG_SERVICES_RES =
  "https://images.pexels.com/photos/6056272/pexels-photo-6056272.jpeg";

export const IMG_SERVICES_COMMUNITY =
  "https://images.unsplash.com/photo-1475503572774-15a45e5d60b9";

export const NAV_ITEMS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Solutions", to: "/services" },
  { label: "Resources", to: "/resources" },
  { label: "Contact", to: "/contact" },
];

export const CONTACT_PLACEHOLDERS = {
  phone: "808-746-1669",
  email: "Support@HawaiiHousingFoundation.Org",
  address: "Kailua-Kona, HI",
};
